import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ConfigApi } from "../../config-api";
import { ApiCallingService } from "../../services/api-calling.service";

@Component({
  selector: "app-lottery-participants",
  templateUrl: "./lottery-participants.component.html",
  styleUrls: ["./lottery-participants.component.css"],
})
export class LotteryParticipantsComponent implements OnInit {
  lotteryId: string = "";
  list: any[] = [];
  lottery: any = {};
  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  loading: boolean = false;

  constructor(
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.lotteryId = this.route.snapshot.paramMap.get("id") || "";
  }

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.loading = true;
    const url =
      ConfigApi.URLS.LOTTERY_PARTICIPATION.LIST +
      `?lotteryId=${this.lotteryId}&page=${this.page - 1}&limit=${this.pageSize}`;

    this.apiCallingService.callAPI({}, "GET", url).subscribe(
      (res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.list = res.data.list || [];
          this.lottery = res.data.lottery || [];
          this.totalCount = res.total || 0;
        }
        this.loading = false;
      },
      (error) => {
        console.error(error);
        this.toastr.error("Failed to load participants");
        this.loading = false;
      },
    );
  }

  viewDetails(participantId: string) {
    this.router.navigate(["/user/lottery-participant-details", participantId]);
  }

  loadPage(page: number) {
    this.page = page;
    this.getList();
  }

  goBack() {
    this.router.navigate(["/user/lottery"]);
  }

  trackById(_index: number, item: any) {
    return item._id;
  }

  getOrdinal(rank: number): string {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = rank % 100;
    return rank + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  }

  getRankClass(rank: number): string {
    if (rank === 1) return "rank-gold";
    if (rank === 2) return "rank-silver";
    if (rank === 3) return "rank-bronze";
    return "rank-other";
  }

  getAvatarClass(rank: number): string {
    if (rank === 1) return "avatar-gold";
    if (rank === 2) return "avatar-silver";
    if (rank === 3) return "avatar-bronze";
    return "avatar-other";
  }

  getInitials(name: string): string {
    if (!name) return "?";
    return name
      .split(/\s+|@/)
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() || "")
      .join("");
  }

  /** Returns winner object if this participationId is a winner, else null */
  getWinnerInfo(participationId: string): any {
    if (!this.lottery?.winners?.length) return null;
    return (
      this.lottery.winners.find(
        (w: any) => w.participationId === participationId,
      ) || null
    );
  }

  /** CSS class for winner table row highlight */
  getWinnerRowClass(participationId: string): string {
    const winner = this.getWinnerInfo(participationId);
    if (!winner) return "";
    if (winner.rank === 1) return "tbl-row-gold";
    if (winner.rank === 2) return "tbl-row-silver";
    if (winner.rank === 3) return "tbl-row-bronze";
    return "tbl-row-other";
  }
}
